import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";

// Components
import { Conference } from "./Conference";

// Context
import { ConferencesContext } from "../../context/conferences";

// Platforms
import { Api } from "../../platforms/api";

// Utils
import { reformatAcfResponse } from "../../utils/fetchUtils";
import { scrollToTop } from "../../utils/scrollUtils";

export const ConferenceContainer = (props) => {
    /**
     * Router Hooks
     */

    const history = useHistory();
    const location = useLocation();
    const params = useParams();

    /**
     * useContext
     */

    const { conferences } = useContext(ConferencesContext);

    /**
     * useState
     */

    const [conference, setConference] = useState(null);
    const [featuredVideos, setFeaturedVideos] = useState([null, null, null]);

    /**
     * useEffect
     */

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const scrollParam = params.get("scroll");

        if (scrollParam === "register") {
            setTimeout(() => {
                scrollToRegister();
            }, 500);
        } else if (scrollParam === "agenda") {
            setTimeout(() => {
                scrollToSessions();
            }, 500);
        } else {
            scrollToTop();
        }

        if (!conference) {
            handleDetectConference();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (conference?.featured_videos) {
            generateFeaturedVideos();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [conference]);

    useEffect(() => {
        handleDetectConference();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.id]);

    /**
     * End Hooks
     */

    async function generateFeaturedVideos() {
        const videos = await Promise.all(
            conference.featured_videos.map((video, i) => {
                return Api.getVideo(
                    { id: video.ID },
                    ({ headers, body: res }) => reformatAcfResponse(res)
                );
            })
        );
        setFeaturedVideos(videos);
    }

    function fetchConference() {
        const slug = props.match.params.id;
        Api.getConferenceBySlug(
            { slug },
            onFetchConferenceSuccess,
            onFetchConferenceError
        );
    }

    function handleDetectConference() {
        const { conference: locationConference } = location?.state || {};
        locationConference
            ? setConference(locationConference)
            : fetchConference();
        scrollToTop();
    }

    function onFetchConferenceError(err) {
        history.push("/conferences");
    }

    function onFetchConferenceSuccess({ headers, body: res }) {
        setConference(reformatAcfResponse(res)[0]);
    }

    function scrollToRegister() {
        document.getElementById("register")?.scrollIntoView();
    }

    function scrollToSessions() {
        document.getElementById("agenda")?.scrollIntoView();
    }

    return (
        <Conference
            {...props}
            conference={conference}
            conferences={conferences}
            featuredVideos={featuredVideos}
            history={history}
            scrollToRegister={scrollToRegister}
            scrollToSessions={scrollToSessions}
        />
    );
};
